import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Pages::VerifyEmail @email={{@model.email}} @signature={{@model.signature}} />\n",{ moduleName: "web-app/templates/verify-email.hbs" })